import { render, staticRenderFns } from "./transform.vue?vue&type=template&id=6b4fca8c"
import script from "./transform.vue?vue&type=script&lang=js"
export * from "./transform.vue?vue&type=script&lang=js"
import style0 from "./transform.vue?vue&type=style&index=0&id=6b4fca8c&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports